import { ColumnDescription } from "react-bootstrap-table-next";
import { ListarParcelasSerasaController } from "../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IListaParcelasSerasa } from "../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import Table from "../../../Table";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

interface IParcelasSerasaProps {
    ID_CHAVE_ERP: string;
}

const filtroDeTextoTable = textFilter({
    placeholder: "Filtro...",
});

export default function ParcelasSerasa(props: IParcelasSerasaProps) {
    const { value: listaParcelasSerasa, loading: listaParcelasSerasaLoading } =
        useAsyncEffect(
            () => ListarParcelasSerasaController(props.ID_CHAVE_ERP),
            []
        );

    const tableviewColumns: Array<ColumnDescription<IListaParcelasSerasa>> = [
        {
            dataField: "ID_CHAVE_ERP_PARCELA",
            text: "ID Chave ERP Parcela",
            filter: filtroDeTextoTable,
        },
        {
            dataField: "numparc_spc",
            text: "Número Parcela",
            filter: filtroDeTextoTable,
        },

        {
            dataField: "obra_spc",
            text: "Obra",
            filter: filtroDeTextoTable,
        },

        {
            dataField: "tipopar_spc",
            text: "Tipo Parcela",
            filter: filtroDeTextoTable,
        },
        {
            dataField: "numparcger_spc",
            text: "Número Parcela Geral",
            filter: filtroDeTextoTable,
        },
        {
            dataField: "valparc_spc",
            text: "Valor Parcela",
            filter: filtroDeTextoTable,
            formatter: (c) => formatMoneyReais(c),
            filterValue: (c) => formatMoneyReais(c as number)
        },
    ];
    return (
        <div>
            <Table
                columns={tableviewColumns}
                data={listaParcelasSerasa ?? []}
                keyField="ID_CASO"
                loading={listaParcelasSerasaLoading}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhuma Parcela Encontrada
                    </div>
                )}
                noHover
                noSearch
                bordered={false}
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
                striped={true}
                rowClasses={"rowClasses"}
                filter={filterFactory()}
            />
        </div>
    );
}
